// extracted by mini-css-extract-plugin
export default {"container":"WorkWithUs_page_container__H75pi"};